import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import NotFound from './pages/NotFound';
import RegulationPage from './pages/RegulationPage';
import NewsPage from './pages/NewsPage';
import QmsNewsPage from './pages/QmsNewsPage';
import KnowledgePage from './pages/KnowledgePage';
import KnowledgeBrowsePage from './pages/KnowledgeBrowsePage';
import KnowledgeHealthPage from './pages/KnowledgeHealthPage';
import SearchResultsPage from './pages/SearchResultsPage';
import LoginPage from './pages/LoginPage';
import ProductPage from './pages/ProductPage';
import SubstancePage from './pages/SubstancePage';
import RasffDeepDivePage from './pages/RasffDeepDivePage';
import LegislationPipelinePage from './pages/LegislationPipelinePage';
import IncidentsPage from './pages/IncidentsPage';
import IncidentDetailPage from './pages/IncidentDetailPage';
import ManageHubPage from './pages/admin/ManageHubPage';
import HazardMappingPage from './pages/admin/HazardMappingPage';
import MrlMappingPage from './pages/admin/MrlMappingPage';
import NotificationsPage from './pages/admin/NotificationsPage';
import SystemStatusPage from './pages/admin/SystemStatusPage';
import SubscribePage from './pages/SubscribePage';
import UnsubscribePage from './pages/UnsubscribePage';
import ManagePreferencesPage from './pages/ManagePreferencesPage';
import SubscribeLandingPage from './pages/SubscribeLandingPage';
import PrivacyPage from './pages/PrivacyPage';
import FeedbackPage from './pages/FeedbackPage';
import SocialAgentPage from './pages/admin/SocialAgentPage';
import Footer from './components/Footer';

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    window.plausible?.('pageview');
  }, [location.pathname]);
  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <RouteTracker />
        <Header title="Food Safety Digest" />

        <div className="main-content">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/regulation/:regulationNumber" element={<RegulationPage />} />
            <Route path="/product/:productId" element={<ProductPage />} />
            <Route path="/substance/:residueId" element={<SubstancePage />} />
            <Route path="/news" element={<NewsPage />} />
            {/* Legacy capitalised path — keep redirect for bookmarks/external links */}
            <Route path="/News" element={<Navigate to="/news" replace />} />
            <Route path="/qms" element={<QmsNewsPage />} />
            <Route path="/rasff" element={<RasffDeepDivePage />} />
            <Route path="/legislation/pipeline" element={<LegislationPipelinePage />} />
            <Route path="/incidents" element={<IncidentsPage />} />
            <Route path="/incidents/:key" element={<IncidentDetailPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/subscribe" element={<SubscribeLandingPage />} />
            <Route path="/subscribe/form" element={<SubscribePage />} />
            <Route path="/unsubscribe" element={<UnsubscribePage />} />
            <Route path="/manage-preferences" element={<ManagePreferencesPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/feedback" element={<FeedbackPage />} />
            {/* /about merged into /subscribe (2026-04-30) — keep redirect for any external links */}
            <Route path="/about" element={<Navigate to="/subscribe" replace />} />

            {/* Protected routes */}
            <Route path="/ServerStatus" element={<Navigate to="/admin/status" replace />} />
            <Route path="/knowledge" element={<ProtectedRoute><KnowledgeBrowsePage /></ProtectedRoute>} />
            <Route path="/knowledge/staging" element={<ProtectedRoute><KnowledgePage /></ProtectedRoute>} />
            <Route path="/knowledge/search" element={<ProtectedRoute><SearchResultsPage /></ProtectedRoute>} />
            <Route path="/knowledge/health" element={<ProtectedRoute><KnowledgeHealthPage /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><ManageHubPage /></ProtectedRoute>} />
            <Route path="/admin/hazards" element={<ProtectedRoute><HazardMappingPage /></ProtectedRoute>} />
            <Route path="/admin/mrl-mappings" element={<ProtectedRoute><MrlMappingPage /></ProtectedRoute>} />
            <Route path="/admin/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
            <Route path="/admin/status" element={<ProtectedRoute><SystemStatusPage /></ProtectedRoute>} />
            <Route path="/admin/social" element={<ProtectedRoute><SocialAgentPage /></ProtectedRoute>} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
    </AuthProvider>
  );
}
